import { EmailStyleImageSizePreset } from 'common/builder/blocks/blockConstants'
import { EmailContentAttachmentSize } from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

const SizeMapping = {
  [EmailStyleImageSizePreset.SMALL]: EmailContentAttachmentSize.S,
  [EmailStyleImageSizePreset.MEDIUM]: EmailContentAttachmentSize.M,
  [EmailStyleImageSizePreset.LARGE]: EmailContentAttachmentSize.L,
  [EmailStyleImageSizePreset.FULL]: EmailContentAttachmentSize.FULL,
  [EmailStyleImageSizePreset.ORIGINAL]: EmailContentAttachmentSize.ORIGINAL,
}
export class EmailContentAttachmentSizeConverter {
  static getFromEmailImageSizePreset(size: EmailStyleImageSizePreset) {
    return SizeMapping[size] || EmailContentAttachmentSize.ORIGINAL
  }
}
